module.exports = __webpack_public_path__ + "static/media/wagon-covered.077ea1c8.svg";